const API = {
    url: 'https://web.hamiltonsupport.com/api'
}

const COLOR_SCHEME = {
    primary: '#00467F',
    actionable: '#1F74B8',
    defaultFontColor: '#3C3C4F'
}

const WINDOW_LOCATION = window.location;
export const PAGE_QUERY_STRING =  WINDOW_LOCATION.hostname === 'localhost' ? window.location.search.substring(1) : window.location.pathname.substring(1);
//For testing on localhost
//export const PAGE_QUERY_STRING =  window.location.pathname.substring(1);
export const ENV_URL = WINDOW_LOCATION.hostname === 'localhost' ? WINDOW_LOCATION.origin + WINDOW_LOCATION.pathname + '?' : WINDOW_LOCATION.origin + '/';
const PAGE = PAGE_QUERY_STRING !== '' ? PAGE_QUERY_STRING : 'home';
console.log("HERE:", PAGE_QUERY_STRING)
const QUERY = 
`
query MyQuery {
  entry: entries(section: "storageSolutions", slug: "${PAGE}") {
    pageTitle: title
    ... on storageSolutions_storageSolutions_Entry {
      pageContent: neoPageBuilder {
        ... on neoPageBuilder_pageSection_BlockType {
          blockType: typeHandle
          blockParallax: storageSolutionsParallax
          blockAlignment: storageSolutionsAlignment
          blockBackgroundColor: storageSolutionsBackgroundColor
          blockBackgroundImage: storageSolutionsBackgroundImage {
            ... on storageSolutions_Asset {
              url
            }
          }
          blockFontColor: storageSolutionsFontColor
          blockID: storageSolutionsSectionId
          blockClasses: storageSolutionsSectionClasses
          blockCustomStyles: storageSolutionsCustomStyles
          blocks: children {
            blockType: typeHandle
            ... on neoPageBuilder_asset_BlockType {
              blockClasses: storageSolutionsSectionClasses
              blockCustomStyles: storageSolutionsCustomStyles
              storageSolutionsAsset {
                ... on storageSolutionsAsset_storageAsset_BlockType {
                  asset {
                    kind
                    mimeType
                    url
                    storageSolutionsVideoPlaceholderImage {
                      url
                    }
                  }
                }
              }
            }
            ... on neoPageBuilder_text_BlockType {
              storageSolutionsText
            }
            ... on neoPageBuilder_heading_BlockType {
              storageSolutionsAlignment
              storageSolutionsHeading {
                ... on storageSolutionsHeading_storageHeading_BlockType {
                  headingSize
                  headingTitle
                  color
                }
                ... on storageSolutionsHeading_storageSupportingText_BlockType {
                  supportingTextContent
                }
              }
              blockType: typeHandle
              storageSolutionsSectionClasses
              storageSolutionsCustomStyles
            }
            ... on neoPageBuilder_imageCards_BlockType {
              storageSolutionsImageCard {
                ... on storageSolutionsImageCard_storageimagecard_BlockType {
                  blockType: typeHandle
                  imageCardLink
                  imageCardContent
                  imageCardAsset {
                    url
                    ... on storageSolutions_Asset {
                      storageSolutionsOptimizedImages {
                        srcset
                        src
                      }
                    }
                  }
                }
              }
              blockType: typeHandle
            }
            ... on neoPageBuilder_hero_BlockType {
              blockType: typeHandle
              storageSolutionsAsset {
                ... on storageSolutionsAsset_storageAsset_BlockType {
                  storageSolutionsAlignment
                  storageSolutionsCustomStyles
                  storageSolutionsSectionClasses
                  asset {
                    mimeType
                    kind
                    url
                    ... on storageSolutions_Asset {
                      storageSolutionsOptimizedImages {
                        srcset
                        src
                      }
                    }
                  }
                }
              }
              storageSolutionsHeading {
                ... on storageSolutionsHeading_storageSupportingText_BlockType {
                  supportingTextContent
                }
                ... on storageSolutionsHeading_storageHeading_BlockType {
                  headingTitle
                  headingSize
                  color
                }
              }
              storageSolutionsButton {
                ... on storageSolutionsButton_storageButton_BlockType {
                  buttonTitle
                  buttonLink
                }
              }
              storageSolutionsAlignment
            }
            ... on neoPageBuilder_button_BlockType {
              storageSolutionsAlignment
              storageSolutionsButton {
                ... on storageSolutionsButton_storageButton_BlockType {
                  buttonLink
                  buttonTitle
                }
              }
              blockType: typeHandle
            }
            ... on neoPageBuilder_featuredPhoto_BlockType {
              storageSolutionsAlignment
              blockType: typeHandle
              children {
                blockType: typeHandle
                storageSolutionsAlignment
                storageSolutionsButton {
                  ... on storageSolutionsButton_storageButton_BlockType {
                    buttonTitle
                    buttonLink
                  }
                }
                ... on neoPageBuilder_icons_BlockType {
                  storageSolutionsIcons {
                    ... on storageSolutionsIcons_storageIcons_BlockType {
                      iconLink
                      iconTitle
                      iconAsset {
                        mimeType
                        url
                        ... on storageSolutions_Asset {
                          storageSolutionsOptimizedImages {
                            srcset
                            src
                          }
                        }
                      }
                    }
                  }
                }
                ... on neoPageBuilder_text_BlockType {
                  storageSolutionsText
                }
                ... on neoPageBuilder_heading_BlockType {
                  storageSolutionsHeading {
                    ... on storageSolutionsHeading_storageSupportingText_BlockType {
                      supportingTextContent
                    }
                    ... on storageSolutionsHeading_storageHeading_BlockType {
                      headingTitle
                      headingSize
                    }
                  }
                  storageSolutionsAlignment
                  storageSolutionsCustomStyles
                  storageSolutionsSectionClasses
                }
              }
              storageSolutionsAsset {
                ... on storageSolutionsAsset_storageAsset_BlockType {
                  id
                  asset {
                    title
                    mimeType
                    kind
                    url
                    ... on storageSolutions_Asset {
                      storageSolutionsOptimizedImages {
                        srcset
                        src
                      }
                    }
                  }
                }
              }
            }
          }
          storageSolutionsCustomStyles
          storageSolutionsBackgroundImage {
            ... on storageSolutions_Asset {
              urls: storageSolutionsOptimizedImages {
                src
                srcset
              }
            }
          }
        }
      }
    }
  }
}
`
;

export function getColorScheme() {
    return COLOR_SCHEME;
}

export function getAPIURL() {
    // Get the preview token from the URL
    
    let m = document.location.href.match(/\btoken=([^&]+)/);
    let token = m ? m[1] : '';

    console.log(`${API.url}?token=${token}`);

    return `${API.url}?token=${token}`;
}

export function getAPIQuery() {
    return QUERY;
}